module.exports = __webpack_public_path__ + "img/manual-receive-03-booking-detail.c6a2f6ef.png";